import { generateActions } from 'helpers/generateActions'

export const LEAVE_MESSAGE = generateActions('LEAVE_MESSAGE')

export const REQUEST_CALL_BACK = generateActions('REQUEST_CALL_BACK')

export const REQUEST_CONTACT_REPS = generateActions("REQUEST_CONTACT_REPS")

export const API_ERROR = 'API_ERROR'
